import React from 'react';
import { Search, Plus, MoreHorizontal, Mail, Filter } from 'lucide-react';
export function TeamDirectory() {
  return <div className="space-y-6 animate-in fade-in duration-500" data-id="element-2489" data-mp="3md6m5vz71ghf">
      <div className="flex justify-between items-center" data-id="element-2490" data-mp="400gqi8lykm3">
        <div data-id="element-2491" data-mp="3zgxmy781q6h">
          <h1 className="text-2xl font-semibold text-slate-900" data-id="element-2492" data-mp="4235z01xs9pr">Directory</h1>
          <p className="text-slate-500 mt-1" data-id="element-2493" data-mp="3w4umkmdqa7v1">
            Manage users, roles, and departments.
          </p>
        </div>
        <button className="bg-slate-900 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-slate-800 transition-colors flex items-center" data-id="element-2494" data-mp="38gbcq2f15n0u">
          <Plus className="h-4 w-4 mr-2" data-id="element-2495" data-mp="3hg7udk305lme" />
          Add User
        </button>
      </div>

      <div className="flex items-center justify-between gap-4" data-id="element-2496" data-mp="3cfsikwydcm6j">
        <div className="relative flex-1 max-w-md" data-id="element-2497" data-mp="woxohrf70z0l">
          <Search className="absolute left-3 top-2.5 h-4 w-4 text-slate-400" data-id="element-2498" data-mp="wnmj5n63nj7d" />
          <input type="text" placeholder="Search by name, role, or department..." className="w-full pl-9 pr-3 py-2 border border-slate-200 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-slate-200" data-id="element-2499" data-mp="rqmbx8xikaeo" />
        </div>
        <button className="flex items-center px-3 py-2 border border-slate-200 rounded-md text-sm font-medium text-slate-700 hover:bg-slate-50" data-id="element-2500" data-mp="3iw0uxvp8f4gl">
          <Filter className="h-4 w-4 mr-2" data-id="element-2501" data-mp="3ntsqr0szzaq2" />
          Filters
        </button>
      </div>

      <div className="bg-white border border-slate-200 rounded-xl shadow-sm overflow-hidden" data-id="element-2502" data-mp="2q8elw7x8j7mc">
        <table className="w-full text-left border-collapse" data-id="element-2503" data-mp="2v7hntjhx4xq3">
          <thead data-id="element-2504" data-mp="305j8u9ywn747">
            <tr className="bg-slate-50 border-b border-slate-200 text-xs uppercase tracking-wider text-slate-500 font-medium" data-id="element-2505" data-mp="305122jem9ai1">
              <th className="p-4" data-id="element-2506" data-mp="34x188tla4zn2">User</th>
              <th className="p-4" data-id="element-2507" data-mp="27gvgxvjnhjho">Role</th>
              <th className="p-4" data-id="element-2508" data-mp="27fu6ntagl110">Department</th>
              <th className="p-4" data-id="element-2509" data-mp="27f15d7u9r3q9">Status</th>
              <th className="p-4 text-right" data-id="element-2510" data-mp="2cewz8e995es3">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-200 text-sm" data-id="element-2511" data-mp="24eh8k296tc6n">
            {[{
            name: 'Jane Doe',
            email: 'jane@acme.com',
            role: 'System Admin',
            dept: 'Operations',
            status: 'Active'
          }, {
            name: 'Sarah Connor',
            email: 'sarah@acme.com',
            role: 'Manager',
            dept: 'Engineering',
            status: 'Active'
          }, {
            name: 'Michael Scott',
            email: 'michael@acme.com',
            role: 'Manager',
            dept: 'Sales',
            status: 'Active'
          }, {
            name: 'Jim Halpert',
            email: 'jim@acme.com',
            role: 'Employee',
            dept: 'Sales',
            status: 'Invited'
          }, {
            name: 'External Consultant',
            email: 'consult@external.com',
            role: 'Evaluator',
            dept: 'Contractor',
            status: 'Active'
          }].map((user, i) => <tr key={i} className="hover:bg-slate-50 transition-colors" data-id="element-2512" data-mp="emz19vp9bqkr" data-mpi={i}>
                <td className="p-4" data-id="element-2513" data-mp="jlad2bz44b5m">
                  <div className="flex items-center" data-id="element-2514" data-mp="jmbm6awkinkp">
                    <div className="w-8 h-8 rounded-full bg-slate-200 flex items-center justify-center text-xs font-medium text-slate-600 mr-3 shrink-0" data-id="element-2515" data-mp="17auugqfmb0cs">
                      {user.name.split(' ').map(n => n[0]).join('')}
                    </div>
                    <div data-id="element-2516" data-mp="12jmo639l3v3u">
                      <div className="font-medium text-slate-900" data-id="element-2517" data-mp="12iuz7bahsvmj">
                        {user.name}
                      </div>
                      <div className="text-xs text-slate-500 flex items-center mt-0.5" data-id="element-2518" data-mp="1q7ns0yvtincx">
                        <Mail className="h-3 w-3 mr-1" data-id="element-2519" data-mp="1v1s05lgtl1fl" />
                        {user.email}
                      </div>
                    </div>
                  </div>
                </td>
                <td className="p-4 text-slate-600" data-id="element-2520" data-mp="1dzyio76v6cb">{user.role}</td>
                <td className="p-4 text-slate-600" data-id="element-2521" data-mp="3tikauus224at">{user.dept}</td>
                <td className="p-4" data-id="element-2522" data-mp="3ok908htxrprj">
                  <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${user.status === 'Active' ? 'bg-emerald-100 text-emerald-800' : 'bg-amber-100 text-amber-800'}`} data-id="element-2523" data-mp="3olal1e0r7qmg">
                    {user.status}
                  </span>
                </td>
                <td className="p-4 text-right" data-id="element-2524" data-mp="gazaspczjnd4">
                  <button className="text-slate-400 hover:text-slate-600" data-id="element-2525" data-mp="be8vw5cx2xta">
                    <MoreHorizontal className="h-5 w-5" data-id="element-2526" data-mp="bbwdxs75sng8" />
                  </button>
                </td>
              </tr>)}
          </tbody>
        </table>
        <div className="p-4 border-t border-slate-200 bg-slate-50 flex items-center justify-between text-sm text-slate-500" data-id="element-2527" data-mp="140tota91jhyy">
          <div data-id="element-2528" data-mp="1bfvtd6gyj448">Showing 1 to 5 of 42 users</div>
          <div className="flex space-x-2" data-id="element-2529" data-mp="1gdoyrxafru3g">
            <button className="px-3 py-1 border border-slate-200 rounded bg-white disabled:opacity-50" disabled data-id="element-2530" data-mp="1geqdcbqnuypx">
              Previous
            </button>
            <button className="px-3 py-1 border border-slate-200 rounded bg-white hover:bg-slate-50" data-id="element-2531" data-mp="1pb7p9h6un0mq">
              Next
            </button>
          </div>
        </div>
      </div>
    </div>;
}